export default __webpack_public_path__ + "static/media/9.08944c8b.jpg";